import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceUsers from "@/components/admin/admin-workspace-users";

const AdminWorkspaceUsersPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceUsers workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/users")({
	component: AdminWorkspaceUsersPage,
});
